import store from '@/store';

export function FLAG_CHECK(key: any) {
  const flags = store.state.flags;
  const org_id = store.state.profile.current_org.org_id;
  const flag = flags.find((f: any) => f.name == key);
  return flag
    ? flag.organizations.some((o: any) => o.org_id == org_id)
    : true;
}